import { crudService } from '../_services'
import { toast } from 'react-toastify'
import { history, stringUtils } from 'utils'
import { ordemServicoAction } from '_actions'

export const ordemServicoCobrancaAction = {
  getOrdemServicoCobranca,
  getOrdemServicoCobrancaSelect,
  getOrdemServicoCobrancaById,
  onChangeProps,
  editOrdemServicoCobrancaInfo,
  createOrdemServicoCobranca,
  deleteOrdemServicoCobrancaById,
  editOrdemServicoCobrancaPaga,
  clear,
  clearDetail,
  notIsLoading,
  isLoading
}

let filterModel = {
  Page: 0,
  Limit: 10,
  Term: ''
};

function getOrdemServicoCobranca(filterModel, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'ordensServicoCobrancas' + stringUtils.serialize(filterModel);
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(changeObrasCobrancasList(response.data.items, response.data.totalRows))
        dispatch(notIsLoading())
      })
      .catch((err) => {
        console.log(err)
        dispatch(notIsLoading())
      })
  }
}

function editOrdemServicoCobrancaPaga(id, idOrdemServico, payload) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'ordensServicoCobrancas/paga/' + id
    crudService
      .put(apiEndpoint, payload)
      .then((response) => {
        if (response && response.request.status === 200) {
          dispatch(notIsLoading())   
          dispatch(ordemServicoAction.getOrdemServicoById(idOrdemServico))
          dispatch(getOrdemServicoCobranca({ IdOrdemServico: idOrdemServico }))
        } else {
          dispatch(notIsLoading())
        }
      })
      .catch((err) => {
        dispatch(failure(err))
        dispatch(notIsLoading())
      })
  }

  function failure(error) {
    return { type: 'EDIT_ORDEM_SERVICO_COBRANCA_FAILURE', error }
  }
}

function getOrdemServicoCobrancaSelect() {
  return (dispatch) => {
    let apiEndpoint = 'ordensServicoCobrancas/select'
    crudService
      .get(apiEndpoint)
      .then((response) => {
        if (response.data) {
          // response.data.unshift({ value: '', text: ' SELECIONE ...' })
          dispatch(changeObrasCobrancasList(response.data))
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

function createOrdemServicoCobranca(payload, idOrgao) {
  return (dispatch) => {
    dispatch(isLoading())
    dispatch(request(payload))
    let apiEndpoint = 'ordensServicoCobrancas'
    crudService
      .post(apiEndpoint, payload)
      .then((response) => {
        if (response.request != undefined && response.request.status === 200) {
          toast.success('Cadastro realizado com sucesso!')
          dispatch(notIsLoading())
          dispatch(clear())
          history.push('/ordensServicosCobrancas');

          let filterModel = {
            IdOrgao: idOrgao
          };

        } else {
          dispatch(notIsLoading())
        }
      })
      .catch((err) => {
        // console.log('err', err)
        dispatch(failure(err))
        dispatch(notIsLoading())
        // toast.error('Oops! Erro ao cadastrar OrdemServicoCobranca! 😥')
      })
  }

  function request(payload) {
    return { type: 'CREATE_ORDEM_SERVICO_COBRANCA_REQUEST', payload }
  }

  function failure(error) {
    return { type: 'CREATE_ORDEM_SERVICO_COBRANCA_FAILURE', error }
  }
}

export function clear() {
  return {
    type: 'ORDEM_SERVICO_COBRANCA_CLEAR'
  }
}

export function clearDetail() {
  return {
    type: 'ORDEM_SERVICO_COBRANCA_CLEAR_DETAIL'
  }
}

function editOrdemServicoCobrancaInfo(id, payload, redirect) {
  return (dispatch) => {
    dispatch(isLoading())
    dispatch(request(payload))
    let apiEndpoint = 'ordensServicoCobrancas/' + id
    return crudService
      .put(apiEndpoint, payload)
      .then((response) => {
        if (response && response.request.status === 200) {
          //dispatch(success(payload))
          dispatch(notIsLoading())
          dispatch(clear())

          var ret = JSON.parse(response.request.responseText);
          let filterModel = {
            IdObra: ret.key
          };
          return response;
        } else {
          dispatch(notIsLoading())
        }
      })
      .catch((err) => {
        //console.log('err', err)
        dispatch(failure(err))
        dispatch(notIsLoading())
        toast.error('Oops! Erro ao alterar OrdemServicoCobranca! 😥')
        throw err;
      })
  }

  function failure(error) {
    return { type: 'EDIT_ORDEM_SERVICO_COBRANCA_FAILURE', error }
  }
}

function request(payload) {
  return { type: 'EDIT_ORDEM_SERVICO_COBRANCA_REQUEST', payload }
}

function success(user) {
  return {
    type: 'EDIT_ORDEM_SERVICO_COBRANCA_SUCCESS',
    user: user
  }
}

function failure(error) {
  return { type: 'EDIT_ORDEM_SERVICO_COBRANCA_FAILURE', error }
}


function getOrdemServicoCobrancaById(id) {
  return (dispatch) => {
    let apiEndpoint = 'ordensServicoCobrancas/' + id
    crudService.get(apiEndpoint).then((response) => {
      dispatch(editObrasCobrancasDetails(response.data))
    })
  }
}

function onChangeProps(props, event) {
  return (dispatch) => {
    if (props === 'imagem' || props === 'obraCobrancaItem') {
      dispatch(handleOnChangeProps(props, event))
    } else {
      dispatch(handleOnChangeProps(props, event.target.value))
    }
  }
}

function deleteOrdemServicoCobrancaById(id, idOrgao) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'ordensServicoCobrancas/' + id
    crudService.deleteDetail(apiEndpoint).then((response) => {
      dispatch(deleteObrasCobrancasDetails())
      dispatch(notIsLoading())
      history.push('/ordensServicosCobrancas');
      let filterModel = {
        IdOrgao: idOrgao
      };
      dispatch(getOrdemServicoCobranca(filterModel))
    })
  }
}
export function changeObrasCobrancasList(ordemServicoCobranca, totalRows) {
  return {
    type: 'FETCHED_ALL_ORDEM_SERVICO_COBRANCA',
    ordemServicoCobranca: ordemServicoCobranca,
    totalRegistros: totalRows
  }
}
export function handleOnChangeProps(props, value) {
  return {
    type: 'ORDEM_SERVICO_COBRANCA_HANDLE_ON_CHANGE',
    props: props,
    value: value
  }
}
export function editObrasCobrancasDetails(ordemServicoCobranca) {
  return {
    type: 'ORDEM_SERVICO_COBRANCA_DETAIL',
    id: ordemServicoCobranca.id,
    dataCobranca: ordemServicoCobranca.dataCobranca,
    dataPagamento: ordemServicoCobranca.dataPagamento,
    idEmpresa: ordemServicoCobranca.idEmpresa,
    caminhoNota: ordemServicoCobranca.caminhoNota,
    caminhoComprovantePagamento: ordemServicoCobranca.caminhoComprovantePagamento,
    empresa: ordemServicoCobranca.empresa,
    ordemServicoCobranca: ordemServicoCobranca.ordemServicoCobranca,
    ordemServico: ordemServicoCobranca.ordemServico,
    valor: ordemServicoCobranca.valor
  }
}
export function createUserInfo() {
  return {
    type: 'ORDEM_SERVICO_COBRANCA_CREATED_SUCCESSFULLY'
  }
}
export function deleteObrasCobrancasDetails() {
  return {
    type: 'DELETED_ORDEM_SERVICO_COBRANCA_DETAILS'
  }
}
export function isLoading() {
  return {
    type: 'ORDEM_SERVICO_COBRANCA_ISLOADING'
  }
}

export function notIsLoading() {
  return {
    type: 'ORDEM_SERVICO_COBRANCA_NOTISLOADING'
  }
}
